import React, { type FC, useEffect } from 'react';
import { Col, Form, Row } from 'antd';
import { InputText, Radio, Space } from '@g2u/ui-kit';

import { AccountType, Condition, type Technician, type WithOptionalDataTest } from 'types';
import { AbnLookup, Section } from 'components';
import styles from './details-fields.module.scss';
import { format } from 'date-fns';

export namespace TechnicianDetailsFields {
  export type Props = {
    title?: string;
    inline?: boolean;
    technician: Technician | null;
  } & WithOptionalDataTest;

  export const $: FC<Props> = (props) => {
    const { inline, title, technician } = props;
    const form = Form.useFormInstance();
    const abn = Form.useWatch('abn', form);

    useEffect(() => {
      if(abn === '' ){
        form.setFieldsValue({
          abn_status: '0',
          gst_reg: Condition.No,
        });
      }
    } , [abn]);

    const handleABNDetailsUpdate = (numberDetails: AbnLookup.NumberDetails) => {
      numberDetails &&
        form.setFieldsValue({
          abn_status: numberDetails.active_status,
          gst_reg: numberDetails.gst_status === 'true' ? Condition.Yes : Condition.No,
          abn_status_update: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
        });
    };

    return (
      <Section.$ title={title ?? 'Account Details'} inline={inline} className={styles.detailsFields}>
        <Space.$ direction={Space.Direction.Vertical}>
          <Row gutter={[32, 8]}>
            <Col xl={{ span: 12 }}>
              <Space.$ direction={Space.Direction.Vertical} size={Space.Size.Small}>
                <Radio.$
                  required
                  initialValue={technician?.type}
                  label="Account Type: "
                  name="type"
                  options={[
                    {
                      label: <>Personal</>,
                      value: AccountType.Personal,
                    },
                    {
                      label: <>Company</>,
                      value: AccountType.Company,
                    },
                  ]}
                  rules={[{ required: true }]}
                />
                <AbnLookup.$
                  form={form}
                  name="abn"
                  defaultAbn={technician?.abn}
                  defaultName={technician?.company}
                  label={'ABN'}
                  companyLabel={'Entity Name'}
                  onSearch={handleABNDetailsUpdate}
                />
              </Space.$>
            </Col>

            <Col xl={{ span: 12 }}>
              <Space.$ direction={Space.Direction.Vertical} size={Space.Size.Small}>
                <Radio.$
                  initialValue={technician?.abn_status?.toString()}
                  label="ABN Active: "
                  name="abn_status"
                  options={[
                    {
                      label: <>Yes</>,
                      value: '1',
                    },
                    {
                      label: <>No</>,
                      value: '0',
                    },
                  ]}
                  disabled
                />

                <Radio.$
                  initialValue={technician?.gst_reg}
                  label="Registered for GST: "
                  name="gst_reg"
                  options={[
                    {
                      label: <>Yes</>,
                      value: Condition.Yes,
                    },
                    {
                      label: <>No</>,
                      value: Condition.No,
                    },
                  ]}
                  disabled
                />
              </Space.$>

              <InputText.$
                name="abn_status_update"
                disabled
                label="Last Updated"
                initialValue={technician?.abn_status_update}
              />

            </Col>
          </Row>
        </Space.$>
      </Section.$>
    );
  };
}
